module.exports = __webpack_public_path__ + "img/img-3.542622b9.webp";